import styled from 'styled-components'

export const CardInfo = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 10vh;
  background-color: #d5f3e7;
  border-radius: 10px;
  padding: 60px 40px;
  justify-content: space-between;
  flex: 1;
`
export const CardContentWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`

export const CardInfoWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 2vw;
`

export const InfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
`

export const CardInfoTitle = styled.div`
  font-weight: bold;
  color: #004b50;
  font-size: 18px;
`

export const CardInfoDescription = styled.div`
  margin-top: 20px;
  color: #538d8a;
  font-size: 16px;
  width: 30vw;
`

export const CardInfoBtn = styled.div`
  background-color: #00a76f;
  border: none;
  width: 5vw;
  padding: 10px;
  border-radius: 10px;
  color: white;
  margin-top: 20px;
  text-align: center;
`
